import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map, tap } from 'rxjs';
import { ServicePathsSettings } from 'src/app/core/configuration/service-paths-settings';
import { PctInfoFascicolo } from '../../models/sections/pct-info-fascicolo';
import { PdaAccessToken } from './pda-auth.service';
import { UserManager } from 'src/app/core/services/user-manager';

@Injectable({
  providedIn: 'root'
})
export class SectionsServiceTsService {


  constructor(
    private http: HttpClient,
    private userManager: UserManager
  ) { }


  getIdFascicoloPCT(idFascicoloTLF): Observable<any> {
    return this.http.post<any>(ServicePathsSettings.URL_PDA_FASCICOLOPCT, { idFascicoloTlf: idFascicoloTLF });
  }

  updatePCT(token: PdaAccessToken, idFascicoloTLF, endpoint): Observable<any> {
    return this.http.post<any>(ServicePathsSettings.URL_PDA_FASCICOLOPCT + "/" + endpoint, { token: token, idFascicoloTlf: idFascicoloTLF });
  }

  getInfoFascicoloPct(idFascicoloPct): Observable<PctInfoFascicolo> {
    return this.http.get<PctInfoFascicolo>(ServicePathsSettings.URL_PDA_FASCICOLOPCT + "/" + idFascicoloPct);
  }

  getRegisters(): Observable<any> {
    return this.http.get<any>(ServicePathsSettings.URL_PDA_REGISTERS);
  }

  getDelegheRicevute(request: any): Observable<any> {
    return this.http.post<any>(ServicePathsSettings.URL_PDA_DELEGATIONS, request);
  }

  updateInfoFascicoloPct(req: PctInfoFascicolo): Observable<PctInfoFascicolo>{
    return this.http.put<any>(ServicePathsSettings.URL_UPDATE_FASCICOLOPCT.replace("{idFascicoloPct}",req.idFascicoloPct), req);
  }

  consultazioneMassiva(token): Observable<any>{
    let utenteLoggato = this.userManager.getUser();
    return this.http.post<any>(ServicePathsSettings.URL_CONSULTAZIONE_MASSIVA.replace("{user}",utenteLoggato.username),token);
  }


}





